module.exports = __webpack_public_path__ + "img/57.09629f2b.jpg";